import { render, staticRenderFns } from "./Anwesenheitsstatisik.vue?vue&type=template&id=271defdf&"
import script from "./Anwesenheitsstatisik.vue?vue&type=script&lang=js&"
export * from "./Anwesenheitsstatisik.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports